import { createFileRoute } from '@tanstack/react-router';

import { TailoredSupplyCreatePage } from '../features/supply/tailored-supply/components/TailoredSupplyCreatePage/TailoredSupplyCreatePage';
import { tailoredSupplyCreateRouteSearchSchema } from '../features/supply/tailored-supply/routeSearch';

export const Route = createFileRoute('/supply/tailored-supply/create')({
  validateSearch: tailoredSupplyCreateRouteSearchSchema,
  component: TailoredSupplyCreatePage,
});
